<template>
  <transition name="fade-up">
    <div
      v-if="showMenu"
      v-click-outside="closeMenu"
      class="header-menu"
    >
      <div class="menu-container">
        <div class="tab-btns">
          <div
            v-for="(item, index) in items"
            class="menu-item"
            :key="index"
            :class="{ active: isActive(item) }"
            @click="navigate(item)">
            {{ item.title | translate }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'HeaderMenu',

  props: {
    showMenu: true
  },

  data: () => ({
    items: [
      { title: 'activities.activities', path: '/app/activities' },
      { title: 'base.consultants', path: '/app/consultants' }
    ]
  }),

  methods: {
    closeMenu () {
      this.$emit('close')
    },

    navigate (item) {
      if (!this.$route.path.includes(item.path)) {
        this.$router.push(item.path)
      }
      this.closeMenu()
    },

    isActive (item) {
      return this.$route.path.includes(item.path)
    }
  }
}
</script>

<style lang="scss">
@import '@/sass/abstracts/_variables.scss';

.header-menu {
  top: 70px;
  position: fixed;
  height: 80px;
  width: 100%;
  background: var(--color-surface);
  z-index: 80;
  box-shadow: 0 1px 14px 0 rgba(0, 0, 0, 0.19);
}

.header-menu .menu-container {
  margin-left: 390px;
  display: flex;
  align-items: center;
  height: 100%;
}

.header-menu .menu-container .tab-btns {
  display: flex;
  margin-right: 24px;
}

.header-menu .menu-container .menu-item {
  cursor: pointer;
  font-size: 17px;
  font-weight: normal;
  padding: 8px 0;
  margin-right: 57px;
}

.header-menu .menu-container .menu-item:not(.active):hover {
  border-bottom: 3px solid rgba(29, 166, 67, .4);
}

.header-menu .menu-container .menu-item.active {
  border-bottom: 3px solid var(--color-primary);
}
</style>
